import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

import PageHeader from "../../components/common/PageHeader";
import DataTable from "../../components/common/DataTable";
import StatusChip from "../../components/common/StatusChip";

import { PAYMENT_STRINGS, COMMON_STRINGS } from "../../constants/strings";
import { getPayments } from "../../services/api";

// 🔥 Redux
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/snackbarSlice";

import "../table-common.css";

const PaymentPage = () => {
  const dispatch = useDispatch();

  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // ================= FETCH =================
  const fetchPayments = async () => {
    try {
      setLoading(true);

      const res = await getPayments();

      console.log("FULL RESPONSE:", res);

      let apiData: any[] = [];

      if (Array.isArray(res.data)) {
        apiData = res.data;
      } else if (Array.isArray(res.data?.data)) {
        apiData = res.data.data;
      }

      // 🔥 TRANSFORM
      const formatted = apiData.map((item: any, index: number) => ({
        _id: item._id || index,

        paymentId: item._id?.slice(-6) || "N/A",

        // 🔥 FIXED (Guest → Guest User)
        user: item.userId?.name?.trim() ? item.userId.name : "Guest User",

        service: item.serviceId?.subSubCategory || "N/A",

        amount: item.price || 0,

        // ❌ method remove

        date: item.date || "-",

        // 🔥 NEW TIME
        time: item.time || "-",

        status: item.paymentStatus?.toLowerCase() || "pending",
      }));

      setRows(formatted);
    } catch (err: any) {
      dispatch(
        showSnackbar({
          message: err.message || COMMON_STRINGS.SOMETHING_WENT_WRONG,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  // ================= FILTER =================
  const filteredRows = rows.filter((row) => {
    const matchSearch = Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase());

    const matchStatus = statusFilter ? row.status === statusFilter : true;

    return matchSearch && matchStatus;
  });

  // ================= COLUMNS =================
  const columns: GridColDef[] = [
    {
      field: "paymentId",
      headerName: PAYMENT_STRINGS.COLUMN_ID,
      flex: 1,
    },
    {
      field: "user",
      headerName: PAYMENT_STRINGS.COLUMN_USER,
      flex: 1,
    },
    {
      field: "service",
      headerName: "Service",
      flex: 1,
    },
    {
      field: "amount",
      headerName: PAYMENT_STRINGS.COLUMN_AMOUNT,
      flex: 1,
      renderCell: (params) => `₹${params.value}`,
    },

    // ❌ METHOD REMOVED

    {
      field: "date",
      headerName: PAYMENT_STRINGS.COLUMN_DATE,
      flex: 1,
    },

    // 🔥 NEW TIME COLUMN
    {
      field: "time",
      headerName: "Time",
      flex: 1,
      renderCell: (params) => params.value || "-",
    },

    {
      field: "status",
      headerName: PAYMENT_STRINGS.COLUMN_STATUS,
      flex: 1,
      renderCell: (params) => <StatusChip status={params.value} />,
    },
  ];

  return (
    <Box>
      {/* 🔥 HEADER */}
      <PageHeader
        title={PAYMENT_STRINGS.TITLE}
        searchValue={searchText}
        onSearchChange={setSearchText}
        searchPlaceholder={PAYMENT_STRINGS.SEARCH_PLACEHOLDER}
        filterValue={statusFilter}
        onFilterChange={setStatusFilter}
        filterOptions={[
          { label: "All Status", value: "" },
          { label: "Paid", value: "paid" },
          { label: "Pending", value: "pending" },
          { label: "Failed", value: "failed" },
        ]}
      />

      {/* 📊 TABLE */}
      <DataTable
        rows={filteredRows}
        columns={columns}
        loading={loading}
        getRowId={(row) => row._id}
        pageSizeOptions={[10, 20, 50]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
      />
    </Box>
  );
};

export default PaymentPage;
